import React, { Component } from "react";
import styles from "./FinancialDetailsDialogBox.module.scss";
import { Dialog, withStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";
import Grid from "@material-ui/core/Grid";
import { withTranslation } from "react-i18next";
import UiDateUtils from "../../../../../utils/UiDateUtils";
import { IS_BRITAIN_MARKET } from "../../../../../utils/EmpUtil";
import {
  CONDITIONED_CREDIT_APP,
  REFERRED,
} from "../../../../../common/Constants";

const StyledDialog = withStyles({
  paper: {
    width: 821,
    maxWidth: 800,
  },
})(Dialog);
const StyledClear = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const DisplayFinanceDetails = (props) => {
  return (
    <div>
      <div>
        <div className={styles.elementHeader}>{props.header}</div>
        <div className={styles.elementBody}>
          {props.value ? props.value : "--"}
        </div>
      </div>
    </div>
  );
};

class FinancialDetailsDialogBox extends Component {
  render() {
    const customerDetails =
      this.props.financialDetails &&
      this.props.financialDetails.buyerInfo &&
      this.props.financialDetails.buyerInfo.length > 0 &&
      this.props.financialDetails.buyerInfo[0];

    const vehicleDetails =
      this.props.financialDetails && this.props.financialDetails.vehicleVO;

    const financeDetails =
      this.props.financialDetails && this.props.financialDetails.financialVO;

    return (
      <StyledDialog open={this.props.boxOpen} onClose={this.props.closePopup}>
        <Grid item>
          <div className={styles.header}>
            <div>
              <h3 className={styles.proposalNumber}>
                {` ${this.props.t(
                  "FinancialDetailsDialogBox.proposalNumber"
                )} #${this.props.proposalNumber}`}
              </h3>
            </div>
            <div>
              <button
                className={styles.cancelbutton}
                name="closeBtn"
                data-testid="closeBtn"
                onClick={this.props.closePopup}
              >
                <StyledClear />
              </button>
            </div>
          </div>

          <div className={styles.eachSection}>
            <div className={styles.eachElement}>
              <h3 className={styles.eachSectionHeader}>
                {" "}
                {this.props.t("FinancialDetailsDialogBox.customerDetails")}{" "}
              </h3>
              <div>
                <div className={styles.elementHeader}>
                  {customerDetails &&
                    customerDetails.individualDetails &&
                    customerDetails.individualDetails.title}{" "}
                  {customerDetails &&
                    customerDetails.individualDetails &&
                    customerDetails.individualDetails.firstName}{" "}
                  {customerDetails &&
                    customerDetails.individualDetails &&
                    customerDetails.individualDetails.surname}
                </div>

                <div>
                  <div className={styles.elementHeader}>
                    {this.props.t("FinancialDetailsDialogBox.typesofCustomer")}
                  </div>
                  <div className={styles.elementBody}>
                    {this.props.t("FinancialDetailsDialogBox.retailCustomer")}
                  </div>
                </div>

                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.dateOfBirth")}
                  value={UiDateUtils.formatDateddmmyyyy(
                    customerDetails &&
                      customerDetails.individualDetails &&
                      customerDetails.individualDetails.dateOfBirth
                  )}
                />
              </div>
            </div>
            <div className={styles.eachElement}>
              <h3 className={styles.eachSectionHeader}>
                {" "}
                {this.props.t("FinancialDetailsDialogBox.contactDetails")}{" "}
              </h3>
              <div>
                {customerDetails &&
                  customerDetails.individualDetails &&
                  customerDetails.individualDetails.emailAddress && (
                    <div className={styles.elementHeader}>
                      {customerDetails.individualDetails.emailAddress}
                    </div>
                  )}

                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.homePhone")}
                  value={
                    customerDetails &&
                    customerDetails.individualDetails &&
                    customerDetails.individualDetails.homeTelephoneNumber
                  }
                />

                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.mobilePhone")}
                  value={
                    customerDetails &&
                    customerDetails.individualDetails &&
                    customerDetails.individualDetails.mobileTelephoneNumber
                  }
                />
              </div>
            </div>
          </div>

          <div className={styles.eachSection}>
            <div className={styles.eachElement}>
              <h3 className={styles.eachSectionHeader}>
                {" "}
                {this.props.t("FinancialDetailsDialogBox.addressDetails")}{" "}
              </h3>
              <div>
                <div className={styles.elementBody}>
                  {customerDetails &&
                  customerDetails.currentAddress &&
                  customerDetails.currentAddress.buildingNumber
                    ? customerDetails.currentAddress.buildingNumber
                    : "--"}{" "}
                  {customerDetails &&
                    customerDetails.currentAddress &&
                    customerDetails.currentAddress.buildingName}{" "}
                  {customerDetails &&
                    customerDetails.currentAddress &&
                    customerDetails.currentAddress.streetName}{" "}
                  {customerDetails &&
                    customerDetails.currentAddress &&
                    customerDetails.currentAddress.town}
                </div>
                <DisplayFinanceDetails
                  header={this.props.t(
                    "FinancialDetailsDialogBox.residenceType"
                  )}
                  value={
                    customerDetails &&
                    customerDetails.currentAddress &&
                    customerDetails.currentAddress.residenceType
                  }
                />

                <DisplayFinanceDetails
                  header={this.props.t(
                    "FinancialDetailsDialogBox.ownershipType"
                  )}
                  value={
                    customerDetails &&
                    customerDetails.currentAddress &&
                    customerDetails.currentAddress.ownershipType
                  }
                />

                <DisplayFinanceDetails
                  header={this.props.t(
                    "FinancialDetailsDialogBox.timeAtAddress"
                  )}
                  value={UiDateUtils.formatDateddmmyyyy(
                    customerDetails &&
                      customerDetails.currentAddress &&
                      customerDetails.currentAddress.timeAtAddress
                  )}
                />
              </div>
            </div>
            <div className={styles.eachElement}>
              <h3 className={styles.eachSectionHeader}>
                {" "}
                {this.props.t(
                  "FinancialDetailsDialogBox.employmentDetails"
                )}{" "}
              </h3>
              <div>
                <DisplayFinanceDetails
                  header={this.props.t(
                    "FinancialDetailsDialogBox.employmentStatus"
                  )}
                  value={
                    customerDetails &&
                    customerDetails.employmentDetails &&
                    customerDetails.employmentDetails.employmentStatus
                  }
                />

                <DisplayFinanceDetails
                  header={this.props.t(
                    "FinancialDetailsDialogBox.occupationType"
                  )}
                  value={
                    customerDetails &&
                    customerDetails.employmentDetails &&
                    customerDetails.employmentDetails.occupationType
                  }
                />

                <DisplayFinanceDetails
                  header={this.props.t(
                    "FinancialDetailsDialogBox.employerName"
                  )}
                  value={
                    customerDetails &&
                    customerDetails.employmentDetails &&
                    customerDetails.employmentDetails.employerName
                  }
                />

                <DisplayFinanceDetails
                  header={this.props.t(
                    "FinancialDetailsDialogBox.timeEmployed"
                  )}
                  value={UiDateUtils.formatDateddmmyyyy(
                    customerDetails &&
                      customerDetails.employmentDetails &&
                      customerDetails.employmentDetails.timeEmployed
                  )}
                />

                <DisplayFinanceDetails
                  header={this.props.t(
                    "FinancialDetailsDialogBox.jobDescription"
                  )}
                  value={
                    customerDetails &&
                    customerDetails.employmentDetails &&
                    customerDetails.employmentDetails.jobDescription
                  }
                />
              </div>
            </div>
          </div>

          <div className={styles.eachSection}>
            <div className={styles.eachElement}>
              <h3 className={styles.eachSectionHeader}>
                {" "}
                {this.props.t("FinancialDetailsDialogBox.bankDetails")}{" "}
              </h3>
              <div>
                <DisplayFinanceDetails
                  header={this.props.t(
                    "FinancialDetailsDialogBox.accountNumber"
                  )}
                  value={
                    customerDetails &&
                    customerDetails.bankVO &&
                    customerDetails.bankVO.bankAccountNumber
                  }
                />

                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.sortCode")}
                  value={
                    customerDetails &&
                    customerDetails.bankVO &&
                    customerDetails.bankVO.bankSortCode
                  }
                />
              </div>
            </div>
            <div className={styles.eachElement}>
              <h3 className={styles.eachSectionHeader}>
                {" "}
                {this.props.t("FinancialDetailsDialogBox.vehicleDetails")}{" "}
              </h3>
              <div>
                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.model")}
                  value={vehicleDetails && vehicleDetails.vehicleModel}
                />

                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.modelYear")}
                  value={vehicleDetails && vehicleDetails.vehicleModelYear}
                />

                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.fuelType")}
                  value={vehicleDetails && vehicleDetails.fuelType}
                />

                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.engineType")}
                  value={vehicleDetails && vehicleDetails.vehicleEngineType}
                />

                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.colour")}
                  value={vehicleDetails && vehicleDetails.vehicleColour}
                />

                <DisplayFinanceDetails
                  header={this.props.t(
                    "FinancialDetailsDialogBox.vehicleIdentification"
                  )}
                  value={
                    vehicleDetails && vehicleDetails.vehicleIdentificationNumber
                  }
                />
              </div>
            </div>
          </div>

          <div className={styles.eachSection}>
            <div className={styles.eachElement}>
              <h3 className={styles.eachSectionHeader}>
                {" "}
                {this.props.t("FinancialDetailsDialogBox.financeDetails")}{" "}
              </h3>
              <div>
                {IS_BRITAIN_MARKET(this.props.selectedMarket) && (
                  <DisplayFinanceDetails
                    header={this.props.t("FinancialDetailsDialogBox.planType")}
                    value={this.props.t(
                      "FinancialDetailsDialogBox.personalFinance"
                    )}
                  />
                )}
                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.advance")}
                  value={financeDetails && financeDetails.advance}
                />
                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.term")}
                  value={financeDetails && financeDetails.finalTerm}
                />
                <DisplayFinanceDetails
                  header={this.props.t("FinancialDetailsDialogBox.mileage")}
                  value={vehicleDetails && vehicleDetails.contractMileage}
                />
              </div>
            </div>
            {this.props.uwDecision &&
              (this.props.uwDecision.decision === CONDITIONED_CREDIT_APP ||
                this.props.uwDecision.decision === REFERRED) &&
              this.props.uwDecision.details &&
              this.props.uwDecision.details.length > 0 && (
                <div className={styles.eachElement}>
                  <h3 className={styles.eachSectionHeader}>
                    {this.props.uwDecision.decision}{" "}
                    {this.props.t("FinancialDetailsDialogBox.details")}
                  </h3>
                  <div>
                    {this.props.uwDecision.details.map((item) => {
                      return (
                        <>
                          <span className={styles.elementBody}>
                            {item.desc}
                          </span>
                          <br />
                        </>
                      );
                    })}
                  </div>
                </div>
              )}
          </div>
        </Grid>
      </StyledDialog>
    );
  }
}

export default withTranslation("emp")(FinancialDetailsDialogBox);
